import { useRoute } from "@react-navigation/native";
import { useGModeService } from "@src/ducks/hooks";
import useSoundService from "@src/ducks/hooks/useSoundService";
import * as ScreenOrientation from "expo-screen-orientation";
import React, { useEffect, useRef, useState } from "react";
import { View } from "react-native";
import GameView from "./GameView";
import Drawer from "./actionbutton";
import CoinsDialog from "./coins-dialog";
import GModeProvider from "./provider";
import useStyles from "./styles.css";

const GameMode = () => {
  const styles = useStyles();
  const route = useRoute<any>();
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const { bgsoundPause, bgsoundPlay } = useSoundService();
  const { onGModeRequest, onLeaveGModeRequest } = useGModeService();

  const lockScreen = async() => {
    try {
      if([5, 15].includes(route?.params?.gameTypeId)){
        document.body.requestFullscreen();
        await ScreenOrientation.lockAsync(ScreenOrientation.OrientationLock.PORTRAIT);
      }
    } catch (error) {
      console.error("Failed to lock orientation:", error);
    }
  };

  const unlockOrientation = async () => {
    try {
      await ScreenOrientation.lockAsync(ScreenOrientation.OrientationLock.LANDSCAPE);
    } catch (error) {
      console.error("Failed to unlock orientation:", error);
    }
  };

  useEffect(() => {
    const handleFullscreenChange = () => {
      const fullscreenElement = document.fullscreenElement || document.webkitFullscreenElement;
      const iframeElement = iframeRef.current;

      if (fullscreenElement === iframeElement) {
        setIsFullscreen(true);
      } else {
        setIsFullscreen(false);
      }
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    document.addEventListener("webkitfullscreenchange", handleFullscreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      document.removeEventListener("webkitfullscreenchange", handleFullscreenChange);
    };
  }, []);

  useEffect(() => {
    lockScreen();
    bgsoundPause();
    onGModeRequest(route.params);
    return () => {
      unlockOrientation();
      onLeaveGModeRequest();
      bgsoundPlay();
    };
  }, []);

  return (
    <GModeProvider>
      <View style={styles.container}>
        <GameView />
        <Drawer />
        <CoinsDialog />
      </View>
    </GModeProvider>
  );
};

export default GameMode;
